import { useMemo } from 'react'
import { useQuery } from 'apollo-client'

import quizContentQuery from './quizContent.graphql'


const useQuizSteps = () => {
  const { data, isFetching, error } = useQuery(quizContentQuery)

  const steps = useMemo<QuizPage.LinkedQuestions>(() => {
    const questionMap = {}
    const questionsList = data?.quizContent.questions || []

    return questionsList.map((question) => {
      const { id: questionId, answers } = question

      questionMap[questionId] = questionMap[questionId] || {}
      Object.assign(questionMap[questionId], question, {
        ...questionMap[questionId],
        stepNumber: parseInt(question?.counter) || 1,
      })

      answers.forEach((answer) => {
        const { nextQuizQuestionId } = answer

        if (nextQuizQuestionId) {
          if (!questionMap[nextQuizQuestionId]?.prevQuizQuestionIds) {
            questionMap[nextQuizQuestionId] = questionMap[nextQuizQuestionId] || {}
            questionMap[nextQuizQuestionId].prevQuizQuestionIds = []
          }

          questionMap[nextQuizQuestionId] = questionMap[nextQuizQuestionId] || {}
          questionMap[nextQuizQuestionId].prevQuizQuestionIds.push(questionId)
        }
      })

      return questionMap[questionId]
    })
  }, [ data?.quizContent.questions ])

  return {
    steps,
    error,
    isFetching,
  }
}

export default useQuizSteps
